import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { DataSubscriptionLogs } from '~/components/settings/admin/dataSubscriptions/DataSubscriptionLogs';

import {
  executionLogSearchDefaults,
  zodExecutionLogSearchSchema,
} from './-searchParams';

export const Route = createFileRoute(
  '/(main)/settings/admin/data-subscription-logs/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/data-subscription-logs/',
    vestigasSupportAccess: true,
  }),
  component: DataSubscriptionLogs,
  search: {
    middlewares: [stripSearchParams(executionLogSearchDefaults)],
  },
  validateSearch: zodExecutionLogSearchSchema,
});

export const ADMIN_DATA_SUBSCRIPTION_LOGS = buildRouteExport({
  Route,
});
